<template>
	<div
      :style="{
        border: isInputFocused || searchText ? '1px solid var(--vote_bar_tint)' : '1px solid #e2e2e2',
      }"
      class="app-top-bar__search-wrapper">
		<input
			class="app-top-bar__search"
			type="text"
			v-model="searchText"
			@input="filterSearching"
			placeholder="Search"
      @focus="isInputFocused = true"
      @blur="isInputFocused = false"
		/>
		<button type="button" @click="closedSearch">
			<Icon type="search" color="var(--button-icon-tint)" :size="24" />
		</button>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import dwh from '@/mixins/Dwh'
export default {
	mixins: [dwh],
	computed: {
		...mapGetters('app', ['search']),
		...mapGetters('auth', ['profile']),
		userId() {
			return this.profile?.user_id || null
		},
		searchText: {
			get() {
				return this.search
			},
			set(value) {
				this.setSearch(value)
			},
		},
	},
  data(){
    return {
      isInputFocused: false,
    }
  },
	methods: {
		...mapActions('app', ['setSearch', 'clearSearch']),
		closedSearch() {
			this.$emit('closeSearch')
		},
		filterSearching(e) {
			const text = e.target.value
			this.searchText = text

			if (this.$route.name === 'directory' && text.trim() !== '') {
				clearTimeout(this.searchTimer)
				this.searchTimer = setTimeout(() => {
					this.toggleDirectorySearch(text)
				}, 1000)
			}
		},
		toggleDirectorySearch(text) {
			this.sendTrigger({
				category: 'Content',
				action: 'directory_search_performed',
				module: 'Directories',
				chapter_id: this.userId,
				data: text,
			})
		},
	},
}
</script>

<style lang="scss">
.app-top-bar {
	&__search-wrapper {
		position: relative;
		display: flex;
		align-items: center;
		flex-wrap: nowrap;
		flex-grow: 1;
		max-height: 40px;
		padding: 12px 10px;
		border-radius: 8px;
		max-width: 585px;
		/*border: 1px solid var(--vote_bar_tint);*/
		background: #fff;

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			background: #fff;
			border-radius: 8px;
			z-index: -1;
		}
	}

	&__search {
		flex-grow: 1;
		font-size: 16px;
		line-height: 100%;
		font-family: Inter, sans-serif;
		color: var(--placeholder_active);
		position: relative;

		&::placeholder {
			color: #9b9b9b;
		}

		&:focus {
			outline: none;
		}
	}
}
</style>
